const COLOR_STOPS = [
  [0, '#eee'],
  [0.02, '#cce4ef'],
  [0.4, '#7dc0d8'],
  [0.6, '#21a9bf'],
  [0.8, '#0078ae'],
];

export default COLOR_STOPS;
